import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "not-found-container" }
const _hoisted_2 = { class: "particles" }
const _hoisted_3 = { class: "not-found-card" }
const _hoisted_4 = { class: "error-actions" }

import { useRouter } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'NotFound',
  setup(__props) {

const router = useRouter();

// 返回首页
const goBackHome = () => {
  router.push('/index/home');
};

// 返回上一页（兼容无历史记录的情况）
const goBack = () => {
  if (window.history.length > 1) {
    router.go(-1);
  } else {
    goBackHome();
  }
};

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(20, (i) => {
        return _createElementVNode("div", {
          class: "particle",
          key: i,
          style: _normalizeStyle({
        left: `${Math.random() * 100}vw`,
        top: `${Math.random() * 100}vh`,
        width: `${Math.random() * 10 + 5}px`,
        height: `${Math.random() * 10 + 5}px`,
        animationDelay: `${Math.random() * 5}s`,
        animationDuration: `${Math.random() * 10 + 10}s`
      })
        }, null, 4)
      }), 64))
    ]),
    _createElementVNode("div", _hoisted_3, [
      _cache[2] || (_cache[2] = _createStaticVNode("<div class=\"error-number\" data-v-fbddd6ee><span class=\"num num-4\" data-v-fbddd6ee>4</span><span class=\"num num-0\" data-v-fbddd6ee>0</span><span class=\"num num-4\" data-v-fbddd6ee>4</span></div><div class=\"error-desc\" data-v-fbddd6ee><h3 data-v-fbddd6ee>页面走丢了 😵</h3><p data-v-fbddd6ee>抱歉，您访问的页面不存在、已删除或路径错误</p></div>", 2)),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_el_button, {
          type: "primary",
          size: "large",
          onClick: goBackHome,
          icon: "House",
          class: "btn-home"
        }, {
          default: _withCtx(() => _cache[0] || (_cache[0] = [
            _createTextVNode(" 返回首页 ")
          ])),
          _: 1,
          __: [0]
        }),
        _createVNode(_component_el_button, {
          type: "default",
          size: "large",
          onClick: goBack,
          icon: "ArrowLeft",
          class: "btn-back"
        }, {
          default: _withCtx(() => _cache[1] || (_cache[1] = [
            _createTextVNode(" 返回上一页 ")
          ])),
          _: 1,
          __: [1]
        })
      ])
    ])
  ]))
}
}

})